
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export interface FanActivityStats {
  likes: number;
  comments: number;
  shares: number;
  posts: number;
}

export const fanActivityService = {
  // Get user's fan activity stats
  async getFanActivityStats(userId: string): Promise<FanActivityStats> {
    console.log('Getting fan activity stats for user:', userId);
    
    try {
      // Get engagement counts from fan_engagement table
      const { data: engagementData, error: engagementError } = await supabase
        .from('fan_engagement')
        .select('engagement_type')
        .eq('fan_id', userId);

      if (engagementError) {
        console.error('Error fetching engagement data:', engagementError);
      }

      // Count different types of activities from fan_engagement
      const engagements = engagementData || [];

      const stats: FanActivityStats = {
        likes: engagements.filter(e => e.engagement_type === 'like').length,
        comments: engagements.filter(e => e.engagement_type === 'comment').length,
        shares: engagements.filter(e => e.engagement_type === 'share').length,
        posts: engagements.filter(e => e.engagement_type === 'post').length
      };

      console.log('Fan activity stats:', stats);
      return stats;
    } catch (error) {
      console.error('Error getting fan activity stats:', error);
      return { likes: 0, comments: 0, shares: 0, posts: 0 };
    }
  },

  // Record a like activity
  async recordLike(userId: string, contentId: number): Promise<void> {
    try {
      const { error } = await supabase
        .from('fan_engagement')
        .insert({
          fan_id: userId,
          content_id: contentId,
          engagement_type: 'like'
        });

      if (error) throw error;
      
      toast.success('Like recorded!');
    } catch (error) {
      console.error('Error recording like:', error);
      toast.error('Failed to record like');
    }
  },

  // Record a comment activity
  async recordComment(userId: string, contentId: number, commentText: string): Promise<void> {
    try {
      const { error } = await supabase
        .from('fan_engagement')
        .insert({
          fan_id: userId,
          content_id: contentId,
          engagement_type: 'comment',
          engagement_data: { comment: commentText }
        });

      if (error) throw error;
      
      toast.success('Comment recorded!');
    } catch (error) {
      console.error('Error recording comment:', error);
      toast.error('Failed to record comment');
    }
  },

  // Record a share activity
  async recordShare(userId: string, contentId: number): Promise<void> {
    try {
      const { error } = await supabase
        .from('fan_engagement')
        .insert({
          fan_id: userId,
          content_id: contentId,
          engagement_type: 'share'
        });

      if (error) throw error;
      
      toast.success('Share recorded!');
    } catch (error) {
      console.error('Error recording share:', error);
      toast.error('Failed to record share');
    }
  }
};
